import { render, staticRenderFns } from "./ComboDate.vue?vue&type=template&id=545d0887&"
import script from "./ComboDate.vue?vue&type=script&lang=js&"
export * from "./ComboDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports